export const remindersSelectOptions = [
    {
        id: 1,
        value: 'welcome_reminder_email_1',
        label: 'Welcome email reminder 1',
    },
    {
        id: 2,
        value: 'welcome_reminder_email_2',
        label: 'Welcome email reminder 2',
    },
    {
        id: 3,
        value: 'welcome_reminder_email_3',
        label: 'Welcome email reminder 3',
    },
    { id: 4, value: 'welcome_reminder_sms_1', label: 'Welcome sms reminder 1' },
    { id: 5, value: 'welcome_reminder_sms_2', label: 'Welcome sms reminder 2' },
    { id: 6, value: 'welcome_reminder_sms_3', label: 'Welcome sms reminder 3' },
    { id: 7, value: 'welcome_reminder_sms_4', label: 'Welcome sms reminder 4' },
];
